import { render, staticRenderFns } from "./ProductSearchDialog.vue?vue&type=template&id=233cdc73&scoped=true&lang=pug&"
import script from "./ProductSearchDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductSearchDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearchDialog.vue?vue&type=style&index=0&id=233cdc73&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233cdc73",
  null
  
)

export default component.exports